import { Box, Container, Flex, Heading, Icon, Image, SimpleGrid, Text } from '@chakra-ui/react';
import { BriefcaseBusinessIcon, HandshakeIcon, TargetIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { Hero } from '../components/Hero';
import { Section, SectionHeading, Reveal } from '../components/Section';
import { ApproachTimeline } from '../components/ApproachTimeline';
import { CtaBanner } from '../components/CtaBanner';
import { Disclaimer } from '../components/Disclaimer';
import { businessFocusCards, images, introFeatures } from '../data/site';
const focusIcons = [TargetIcon, BriefcaseBusinessIcon, HandshakeIcon];
export function Home() {
  return <>
      <Seo title="Futuramy Investment LLC | Business & Strategic Opportunities" description="Futuramy Investment LLC is a privately held U.S. company based in Plantation, Florida, focused on business opportunities, strategic initiatives and long-term value creation." path="/" data-id="element-234" data-mp="29ihp3p2h0blt" />
      <Hero data-id="element-235" data-mp="30wrnkc0kxpdf" />

      <Section data-id="element-236" data-mp="30xb9s4x9izx9">
        <Flex direction={{
        base: 'column',
        lg: 'row'
      }} gap={{
        base: 10,
        lg: 20
      }} data-id="element-237" data-mp="30vqe2bz7paxt">
          <Box flex="1" data-id="element-238" data-mp="2vx6swdsg036i">
            <SectionHeading eyebrow="Company introduction" title="Focused on Long-Term Value" intro="Futuramy Investment LLC is a privately held company based in Plantation, Florida. We take a thoughtful and disciplined approach to business opportunities, strategic initiatives and long-term growth." maxW="560px" data-id="element-239" data-mp="2vyzzjt322nei" />
          </Box>
          <Box flex="1" data-id="element-240" data-mp="2d6f9ejeqqwee">
            <SimpleGrid columns={1} spacing={0} borderTop="1px solid" borderColor="navy.100" data-id="element-241" data-mp="2d545mjlapona">
              {introFeatures.map((feature, index) => <Reveal key={feature.number} delay={index * 0.08} data-id="element-242" data-mp="239sppxy5ibdy" data-mpi={index}>
                  <Box py={7} borderBottom="1px solid" borderColor="navy.100" data-id="element-243" data-mp="1z7fw27woi3xj">
                    <Flex gap={6} align="flex-start" data-id="element-244" data-mp="1z9ijck6g5iyk">
                      <Text fontSize="sm" fontWeight={600} color="accent.500" letterSpacing="0.08em" pt={1} minW="28px" data-id="element-245" data-mp="1u831f0zkfske">
                        {feature.number}
                      </Text>
                      <Box data-id="element-246" data-mp="1aovwry62nf15">
                        <Heading as="h3" fontSize="lg" mb={2} data-id="element-247" data-mp="1fl4cpds3fc9d">
                          {feature.title}
                        </Heading>
                        <Text fontSize="sm" color="navy.500" lineHeight={1.8} data-id="element-248" data-mp="23bqewoff22bg">
                          {feature.description}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Reveal>)}
            </SimpleGrid>
          </Box>
        </Flex>
      </Section>

      <Box bg="navy.50" borderY="1px solid" borderColor="navy.100" data-id="element-249" data-mp="2mackoglvohlp">
        <Section data-id="element-250" data-mp="2m7zrf7ao6ktc">
          <SectionHeading eyebrow="Business focus" title="Our Business Focus" intro="Our approach is centered on identifying opportunities, evaluating potential and developing relationships that can create sustainable business value." data-id="element-251" data-mp="2r0sw5v651t5f" />
          <SimpleGrid columns={{
          base: 1,
          md: 3
        }} spacing={6} data-id="element-252" data-mp="akmtp2ypb3am">
            {businessFocusCards.map((card, index) => <Reveal key={card.number} delay={index * 0.08} h="100%" data-id="element-253" data-mp="kciwusfn9jlp" data-mpi={index}>
                <Box h="100%" bg="white" border="1px solid" borderColor="navy.100" p={{
              base: 7,
              md: 8
            }} transition="border-color 200ms ease, transform 200ms ease" _hover={{
              borderColor: 'navy.200',
              transform: 'translateY(-2px)'
            }} data-id="element-254" data-mp="ken6lr085ctw">
                  <Icon as={focusIcons[index]} boxSize={6} color="accent.600" strokeWidth={1.5} mb={6} data-id="element-255" data-mp="n00rckkhb7n" />
                  <Heading as="h3" fontSize="xl" mb={3} data-id="element-256" data-mp="1h18bm9vz5w3g">
                    {card.title}
                  </Heading>
                  <Text fontSize="sm" color="navy.500" lineHeight={1.8} data-id="element-257" data-mp="1c5syxl9pe68m">
                    {card.short}
                  </Text>
                </Box>
              </Reveal>)}
          </SimpleGrid>
        </Section>
      </Box>

      <Section data-id="element-258" data-mp="2hbjdqext950u">
        <SectionHeading eyebrow="Our approach" title="A Thoughtful Approach" intro="A consistent, structured process guides how we consider each opportunity — from initial review through practical business development." data-id="element-259" data-mp="2hb17qqlcjcfq" />
        <ApproachTimeline data-id="element-260" data-mp="2vbu4lhz4ejm0" />
      </Section>

      <Box bg="navy.50" borderY="1px solid" borderColor="navy.100" data-id="element-261" data-mp="2vaj35ot5dny2">
        <Container maxW="1200px" px={{
        base: 6,
        md: 8
      }} py={{
        base: 12,
        md: 16
      }} data-id="element-262" data-mp="3020s1ehwby2o">
          <Image src={images.focus} alt="Abstract composition of intersecting arcs and a fine grid representing strategy and connected opportunities" w="100%" h={{
          base: '200px',
          md: '320px'
        }} objectFit="cover" border="1px solid" borderColor="navy.100" loading="lazy" data-id="element-263" data-mp="351nfegrfuup7" />
        </Container>
      </Box>

      <Disclaimer data-id="element-264" data-mp="ydmr9vhbynr4" />
      <CtaBanner data-id="element-265" data-mp="yd4y57pyspnf" />
    </>;
}